// extracted by mini-css-extract-plugin
export default {"container":"style_container__ATbw9","errorTitle":"style_errorTitle__-Xear","addStoreContainer":"style_addStoreContainer__k-n4y","storeBtn":"style_storeBtn__5DCvT"};